<template>
<div class="">
<user-top></user-top>
<div class="ht tc mt50">工作经历</div>
<div class="millia">
<ul class="expList">
<li v-for="(jobGroups,id) of jobGroup" :key="id" :id="jobGroups.id">
<p><label>公司名称：</label>{{jobGroups.company_name}}</p>
<p><label>就职岗位：</label>{{jobGroups.position}}</p>
<p><label>岗位说明：</label>{{jobGroups.work_exp}}</p>
<p><label>开始时间：</label>{{jobGroups.start_time}}</p>
<p><label>离职时间：</label>{{jobGroups.end_time}}</p>

<div class="btGroup">
<!-- <span class="editBt">编辑</span> -->
<span class="deleteBt" @click="JobDelete(jobGroups.id)">删除</span>
</div>
</li>
</ul>
<div class="layui-form groupList" lay-filter="jobInfo">
<form action="">
<ul class="UserList">
<li>
<input type="text" name="company_name" placeholder="请输入曾就职公司名称" class="layui-input" lay-verify="required" maxlength="30">
</li>
<li>
<input type="text" name="position" placeholder="请输入曾就职职位名称" class="layui-input" lay-verify="required" maxlength="30">
</li>
<li>
<input type="text" name="start_time" class="layui-input timeFlie" placeholder="就职时间" id="jobStartTime" lay-verify="required">
</li>
<li>
<input type="text" name="end_time" class="layui-input timeFlie" placeholder="离职时间" id="jobEndTime" lay-verify="required">
</li>
<li>
<textarea name="work_exp" v-model="textareaData" placeholder="请输入在职岗位职责说明" class="layui-textarea" lay-verify="required" maxlength="100"></textarea>
<span class="textareaLength">({{textareaData.length}}/100)</span>
</li>
<li>
<button type="button" lay-submit class="layui-btn layui-btn-fluid layui-btn-normal" lay-filter="jobSave">确认工作经历</button>
</li>
<li>
</li>
</ul>
</form>
</div>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
import { watch } from 'fs';
export default {
    name: "JobExp",
    inject: ["reload"],
    components:{
        UserTop
    },
    data () {
        return {
            //jobData
            jobList:{},
            jobGroup: {},
            textareaData:""//输入字符
        }
    },
    mounted () {
        this.getJobList()
        //表单相关
        var that = this;
        layui.use('form', function(){
            var $ = layui.$;
            var form = layui.form;
            //工作经历表单提交
            form.on('submit(jobSave)', function(data){
                var BasicDatas = JSON.parse(JSON.stringify(data.field));
                that.jobList = BasicDatas;
                that.jobSave();
            });
        });

        //时间选择
        layui.use('laydate', function(){
            var laydate = layui.laydate;
            //工作经历开始时间
            laydate.render({
                elem:'#jobStartTime',
                type:'month',
                trigger:'click',
            });
            //工作经历结束时间
            laydate.render({
                elem:'#jobEndTime',
                type:'month',
                trigger:'click',
            });
        });
    },
    methods: {
        //工作经历提交
        jobSave(){
            let url = "api/user/saveWorkExp";
            var param = {
                    company_name:this.jobList.company_name,
                    position:this.jobList.position,
                    start_time:this.jobList.start_time,
                    end_time:this.jobList.end_time,
                    work_exp:this.jobList.work_exp,
            }
            this.$ajax.post(url,param).then(function (response) {
                 console.log(response.data);
                if (response.data.status==1) {
                    layer.alert("工作经历保存成功成功");
                    this.reload();
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
            //this.jobList.push(param);
        },

        //获取用户工作经历信息
        getJobList() {
            let url = "api/user/getUserInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.jobGroup = response.data.data.work_exp;
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

        //删除工作经历
        JobDelete(id){
            let url = "api/user/delWorkExp";
            let params = {
                id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("个人工作经历删除成功!");
                    this.reload();
                    //console.log(this.allData);
                }else{
                    layer.alert(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },

    },
    watch: {
        textareaData() {
            if(this.textareaData.length>100){
                alert("字数超啦！");
                this.textareaData=String(this.textareaData).slice(0,100)
            }
        }
    }
}
</script>
<style scoped>
.UserList li{position:relative;}
.UserList li .textareaLength{position:absolute;right:5px;bottom:5px;color:#999;font-size:1.2rem;}
.layui-textarea{min-height:200px;}
</style>